export const DATA_URL = 'Production.data.unityweb';
export const CODE_URL = 'Production.wasm.unityweb';
export const FRAMEWORK_URL = 'Production.framework.js.unityweb';
